<template>
  <el-table-column
    prop="customer_postal_code"
    sortable="custom"
    label="Irányítószám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.customer_postal_code }}</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer_address.postal_code',
};
</script>
